export default {
  init() {

  },
  finalize() {

    const $navigation = $('header.navigation');
    const $submenu = $navigation.find('.nav-submenu');
    const $submenusWrap = $submenu.find('.nav-submenus-wrap');

    /**
     * Functions
     */
    function hideSubmenu() {
      setTimeout(() => {
        // Check if currently hovering over another mouse item
        var hasHover = false;

        $navigation.find('.nav-link.nav-link-has-children').each(function() {
          if ($(this).is(':hover') || $(this).is(':focus')) {
            hasHover = true;
          }
        });

        if ($submenu.is(':hover') || $submenu.is(':focus-within')) {
          hasHover = true;
        }

        if (!hasHover) {
          $submenu.removeClass('open');
        }
      }, 150);
    }

    function showSubmenu($navItem) {
      const $theSubmenu = getTheSubmenu($navItem);

      if (!$submenu.hasClass('open')) {
        // Submenu is not already open. Open it
        $submenu.addClass('open');

        // Set submenu animation durations to zero
        $submenusWrap.addClass('no-animation');
        $submenu.addClass('no-animation');
      } else {
        // Submenu is already open, remove no-animation restrictors
        $submenusWrap.removeClass('no-animation');
        $submenu.removeClass('no-animation');
      }

      // Set width/height of submenu based on currently open item
      $submenusWrap.css({ 'width': $theSubmenu.outerWidth() });
      $submenusWrap.css({ 'height': $theSubmenu.outerHeight() });

      // Centre to nav item
      centreSubmenuToNavItem($navItem);

      // Go to the nav item
      goToSubmenuLocation($navItem);
    }

    function getTheSubmenu($navItem) {
      const submenuIndex = $navItem.find('.nav-link').data('index');
      return $submenu.find(`.nav-submenu-item[data-index="${submenuIndex}"]`);
    }

    function goToSubmenuLocation($navItem) {
      const $theSubmenu = getTheSubmenu($navItem);

      // Set active class
      $submenusWrap.find('div').removeClass('active');
      $theSubmenu.addClass('active');

      // Get the x position of this submenu relative to the x position of the first submenu
      const firstSubmenuX = $($submenusWrap.find('div')[0]).offset().left;
      const thisSubmenuX = $theSubmenu.offset().left;

      const difference = thisSubmenuX - firstSubmenuX;
      $submenusWrap.css({ 'transform': `translate(-${difference}px)` });

      $submenusWrap.find('div a').attr('tabindex', '-1');
      $theSubmenu.find('a').attr('tabindex', '0');
    }

    function centreSubmenuToNavItem($navItem) {
      const navItemLeft = $navItem.offset().left;
      const navItemWidth = $navItem.outerWidth();
      
      $submenu.css({ 'left': navItemLeft + (navItemWidth / 2) + 'px' });

      const submenuWidth = getTheSubmenu($navItem).outerWidth();

      $submenu.css({ 'transform': `translateX(-${submenuWidth / 2}px)` });
    }

    /**
     * Triggers
     */
    $navigation.find('.nav-link.nav-link-has-children').on('mouseenter focus', function() {
      showSubmenu($(this).parent());
    });

    $navigation.find('.nav-link.nav-link-has-children').on('keydown', function(e) {
      if (e.keyCode == 9 && !e.shiftKey) {
        e.preventDefault();
        e.stopPropagation();

        // We want to tab into the submenu
        $submenusWrap.find('div.active .nav-submenu-children a:first-of-type').focus();
      }
    });
    
    $navigation.find('.nav-link.nav-link-has-children').on('mouseleave blur', function() {
      hideSubmenu();
    });

    $submenu.on('mouseleave', function() {
      hideSubmenu();
    });

    $submenu.find('a').on('blur', function() {
      hideSubmenu();
    });

    $submenu.find('a').on('keydown', function(e) {
      if (e.keyCode == 9 && !e.shiftKey && $(this).is(':last-of-type')) {
        e.preventDefault();
        e.stopPropagation();

        // Reached the end of the submenu
        const submenuIndex = $(this).parents('.nav-submenu-item').data('index');
        const $submenuItem = $navigation.find(`.nav-link[data-index="${submenuIndex}"]`);

        $submenuItem.parent().next().find('a').focus();
      }
    });

    // Set languages
    $('#gtranslate-languages .option a').each(function() {
      const $this = $(this);
      const languageName = $(this).attr('title');

      // Desktop
      const $option = $(`<a href="#" class="language-selector-dropdown-item">${languageName}</a>`);
      $('.language-selector-dropdown').append($option);
      
      $option.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

    // Fade out labels first
      $('.current-language, .first-footer-language span').fadeOut(150, () => {

      $this.trigger('click');

      // Wait for <html lang> attribute to change
      const observer = new MutationObserver((mutations, obs) => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'lang') {
            // Update labels after lang attr change
            setDesktopLanguageName();
            setMobileLanguageName();

            // Fade labels back in
            $('.current-language, .first-footer-language span').fadeIn(150);

            obs.disconnect();
          }
        });
      });

      observer.observe(document.documentElement, { attributes: true });
      });
    });



      // Mobile
      const $optionMobile = $(`<a href="#" class="language-switch-item">${languageName}</a>`);
      $('.language-switch-drop').append($optionMobile);

      $optionMobile.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $this.trigger('click');

        setTimeout(() => {
          setDesktopLanguageName();
          setMobileLanguageName();
        }, 600);
      });
    });

    // Open language switcher desktop
    $('.language-selector-trigger').on('click', function() {
      $('.language-selector-dropdown').toggleClass('d-none');
    });

    // Open language switcher mobile
    $('.first-footer-language').on('click', function() {
      $('.language-switch-drop').toggleClass('d-none');
    });

    $(window).on('click', function(e) {
      // Desktop
      if (!$(e.target).hasClass('language-selector-dropdown') && !$(e.target).hasClass('language-selector-trigger') 
        && $(e.target).parents('.language-selector-trigger').length == 0 && $(e.target).parents('.language-selector-dropdown').length == 0) {

        $('.language-selector-dropdown').addClass('d-none');
        setMobileLanguageName();
      }
      
      // Mobile
      if (!$(e.target).hasClass('language-switch-drop') && !$(e.target).hasClass('first-footer-language') 
        && $(e.target).parents('.first-footer-language').length == 0 && $(e.target).parents('.language-switch-drop').length == 0) {

        $('.language-switch-drop').addClass('d-none');
        setMobileLanguageName();
      }
    });

    // Set currently selected name (mobile)
    function setMobileLanguageName() {
      const currentLangCode = $('html').attr('lang');
      $('#gtranslate-languages .option a').each(function() { 
        const onclickEvent = $(this).attr('onclick');

        if (onclickEvent.indexOf(`en|${currentLangCode}`) !== -1) {
          const langName = $(this).attr('title');
          $('.first-footer-language span').html(langName);
        }

        if (currentLangCode == 'en') {
          $('.first-footer-language span').html('English');
        }
      });
    }

    setMobileLanguageName();

    // Set currently selected name (desktop)
   function setDesktopLanguageName() {
    // Normalize current lang code to first part before dash (e.g. 'cy-GB' -> 'cy')
    let currentLangCode = $('html').attr('lang') || 'en';
    currentLangCode = currentLangCode.split('-')[0];

    // Define the language codes
    const englishCode = 'en';
    const welshCode = 'cy';

    let languageToDisplay = ''; // This will hold the abbreviated language name to display

    // Determine what to display based on the current language
    if (currentLangCode === welshCode) {
        // If current language is Welsh, display 'Eng' (as the opposite, shortened English)
        languageToDisplay = 'Eng';
    } else {
        // If current language is English (or any other language not Welsh),
        // display 'Cym' (shortened Welsh) as the opposite.
        languageToDisplay = 'Cym';
    }

    // Update the .current-language element with the determined abbreviated language name
    $('.current-language').html(languageToDisplay);
}

// Call the function to set the language name on page load
setDesktopLanguageName();
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/other/navigation.js